import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGE_CODES } from "./languages";

import pl from "./locales/pl.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import pt from "./locales/pt.json";
import nl from "./locales/nl.json";
import cs from "./locales/cs.json";
import sk from "./locales/sk.json";
import sl from "./locales/sl.json";
import hr from "./locales/hr.json";
import bg from "./locales/bg.json";
import ro from "./locales/ro.json";
import hu from "./locales/hu.json";
import el from "./locales/el.json";
import da from "./locales/da.json";
import sv from "./locales/sv.json";
import fi from "./locales/fi.json";
import et from "./locales/et.json";
import lv from "./locales/lv.json";
import lt from "./locales/lt.json";
import ga from "./locales/ga.json";
import mt from "./locales/mt.json";

const resources = {
  pl: { translation: pl },
  en: { translation: en },
  de: { translation: de },
  fr: { translation: fr },
  es: { translation: es },
  it: { translation: it },
  pt: { translation: pt },
  nl: { translation: nl },
  cs: { translation: cs },
  sk: { translation: sk },
  sl: { translation: sl },
  hr: { translation: hr },
  bg: { translation: bg },
  ro: { translation: ro },
  hu: { translation: hu },
  el: { translation: el },
  da: { translation: da },
  sv: { translation: sv },
  fi: { translation: fi },
  et: { translation: et },
  lv: { translation: lv },
  lt: { translation: lt },
  ga: { translation: ga },
  mt: { translation: mt },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    nonExplicitSupportedLngs: true, // np. "de-AT" -> "de"
    interpolation: { escapeValue: false },
    detection: {
      // Najpierw zapisany wybór, potem język przeglądarki
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "appLanguage",
      caches: ["localStorage"],
    },
  });

export default i18n;
